import { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";

const SmallScreenNav = () => {
    const [isNavOpen, setIsNavOpen] = useState(false);

    const toggleNav = () => {
        setIsNavOpen(!isNavOpen);
    };

    const [isDropdownOpen, setIsDropdownOpen] = useState(false);

    const [openDropdown, setOpenDropdown] = useState(null);

    const toggleDropdown = (menu) => {
        setOpenDropdown(openDropdown === menu ? null : menu);
    };

    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    const toggleOpenDropdown = (e) => {
        e.stopPropagation();
        setIsOpen((prev) => !prev);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener("click", handleClickOutside);
        return () => document.removeEventListener("click", handleClickOutside);
    }, []);

    return (
        <div id="smallscreen-navigation" className="smallscreen-navigation-main-block">
            <div className="container">
                <nav className="navbar navbar-expand-lg">
                    <Link className="navbar-brand" to="#">Menu</Link>

                    <button
                        className="navbar-toggler"
                        type="button"
                        onClick={toggleNav}
                        aria-expanded={isNavOpen}
                        aria-label="Toggle navigation"
                    >
                        <span className="navbar-toggler-icon" />
                    </button>

                    <div className={`navbar-collapse collapse ${isNavOpen ? "show" : ""}`} id="navbarNavDropdownOne">
                        <ul className="navbar-nav">
                            <li className="nav-item dropdown">
                                <Link
                                    className={`nav-link dropdown-toggle ${isDropdownOpen ? "show" : ""}`}
                                    onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                                    aria-expanded={isDropdownOpen}
                                >
                                    Home <i className="flaticon-down-arrow"></i>
                                </Link>
                                <ul className={`dropdown-menu ${isDropdownOpen ? "show" : ""}`}>
                                    <li><Link className="dropdown-item" to="/">Home Page 01</Link></li>
                                    <li><Link className="dropdown-item" to="/Hometwo">Home Page 02</Link></li>
                                    <li><Link className="dropdown-item" to="/HomeThree">Home Page 03</Link></li>
                                    <li><Link className="dropdown-item" to="/Homefour">Home Page 04</Link></li>
                                    <li><Link className="dropdown-item" to="/Homefive">Home Page 05</Link></li>
                                    <li><Link className="dropdown-item" to="/Homesix">Home Page 06</Link></li>
                                    <li><Link className="dropdown-item" to="/Homeseven">Home Page 07</Link></li>
                                </ul>
                            </li>
                            <li className="nav-item dropdown">
                                <Link
                                    className={`nav-link dropdown-toggle ${openDropdown === "shop" ? "show" : ""}`}
                                    onClick={() => toggleDropdown("shop")}
                                    aria-expanded={openDropdown === "shop"}
                                >
                                    Shop <i className="flaticon-down-arrow" />
                                </Link>
                                <ul className={`dropdown-menu ${openDropdown === "shop" ? "show" : ""}`}>
                                    <li><Link className="dropdown-item" to="/Shop">Shop</Link></li>
                                    <li><Link className="dropdown-item" to="/shop-filter">Sidebar Shop 01</Link></li>
                                    <li><Link className="dropdown-item" to="/shop-filter2">Sidebar Shop 02</Link></li>
                                    <li><Link className="dropdown-item" to="/ShopDetails">Shop Details</Link></li>
                                </ul>
                            </li>
                            <li className="nav-item">
                                <Link className="nav-link" to="/Shop" title="">
                                    Smartwatches
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link className="nav-link" to="/Shop" title="">
                                    Laptops &amp; Computers
                                </Link>
                            </li>
                            <li className="nav-item dropdown">
                                <Link
                                    className={`nav-link dropdown-toggle ${openDropdown === "blog" ? "show" : ""}`}
                                    onClick={() => toggleDropdown("blog")}
                                    aria-expanded={openDropdown === "blog"}
                                >
                                    Blog <i className="flaticon-down-arrow" />
                                </Link>
                                <ul className={`dropdown-menu ${openDropdown === "blog" ? "show" : ""}`}>
                                    <li>
                                        <Link className="dropdown-item" to="/Blog">
                                            Blog
                                        </Link>
                                    </li>
                                    <li>
                                        <Link className="dropdown-item" to="/BlogDetails">
                                            Blog Details
                                        </Link>
                                    </li>
                                </ul>
                            </li>
                            <li className="nav-item dropdown">
                                <Link
                                    className={`nav-link dropdown-toggle ${openDropdown === "pages" ? "show" : ""}`}
                                    onClick={() => toggleDropdown("pages")}
                                    aria-expanded={openDropdown === "pages"}
                                >
                                    Pages <i className="flaticon-down-arrow" />
                                </Link>
                                <ul className={`dropdown-menu ${openDropdown === "pages" ? "show" : ""}`}>
                                    <li><Link className="dropdown-item" to="/Aboutus">About Us</Link></li>
                                    <li><Link className="dropdown-item" to="/Affiliate">Affiliate</Link></li>
                                    <li><Link className="dropdown-item" to="/Career">Career</Link></li>
                                    <li><Link className="dropdown-item" to="/Faq">FAQ</Link></li>
                                    <li><Link className="dropdown-item" to="/Error">404</Link></li>
                                    <li><Link className="dropdown-item active" to="/Contactus">Contact Us</Link></li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                </nav>
                <div className="smallscreen-bottom-bar">
                    <div className="row">
                        <div className="col">
                            <div className="dropdown category-dropdown" ref={dropdownRef}>
                                <button
                                    className={`btn btn-secondary dropdown-toggle ${isOpen ? "show" : ""}`}
                                    onClick={toggleOpenDropdown}
                                >
                                    <i className="flaticon-hamburger" />
                                </button>
                                {isOpen && (
                                    <ul
                                        className={`dropdown-menu ${isOpen ? "show" : ""}`}
                                        style={{
                                            position: "absolute",
                                            inset: "auto auto 0px 0px",
                                            margin: "0px",
                                            transform: "translate3d(0px, -26px, 0px)"
                                        }}
                                    >
                                        <li><Link className="dropdown-item" to="#">Smartphones</Link></li>
                                        <li><Link className="dropdown-item" to="#">Tablets</Link></li>
                                        <li><Link className="dropdown-item" to="#">Smartwatches</Link></li>
                                        <li><Link className="dropdown-item" to="#">Fitness trackers</Link></li>
                                        <li><Link className="dropdown-item" to="#">Headphones</Link></li>
                                        <li><Link className="dropdown-item" to="#">Speakers</Link></li>
                                        <li><Link className="dropdown-item" to="#">Gaming consoles</Link></li>
                                        <li><Link className="dropdown-item" to="#">Portable chargers</Link></li>
                                        <li><Link className="dropdown-item" to="#">Bluetooth earphones</Link></li>
                                    </ul>
                                )}
                            </div>
                        </div>
                        <div className="col">
                            <div className="wishlist-icon-block">
                                <Link to="/WishList" title="">
                                    <i className="flaticon-love" />
                                    <span className="icon-badge">1</span>
                                </Link>
                            </div>
                        </div>
                        <div className="col">
                            <Link to="/" title="">
                                <i className="flaticon-home" />
                            </Link>
                        </div>
                        <div className="col">
                            <div className="cart-icon-block">
                                <div className="cart-icon">
                                    <Link to="/Cart" title="">
                                        <i className="flaticon-shopping-cart" />
                                        <span className="icon-badge">0</span>
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <div className="col">
                            <div className="user-icon">
                                <i className="flaticon-user" />
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default SmallScreenNav;
